import { motion } from "framer-motion";
import { useEffect } from "react";

export const EASE = [0.25, 0, 0, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 14 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.4, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | Stige Lifesciences` : "Stige Lifesciences — Global Healthcare Sourcing & Export";
  }, [title]);
};
